/* global attachEvent, slideUp, slideDown, breakpointMd, windowWidth */

// **********************************************************
// Main menu dropdown
// **********************************************************

function closeOtherMenu() {
  const menuItem = document.querySelectorAll('.menu__item.is-open');
  menuItem.forEach((el) => {
    const openDropdown = el.querySelector('[data-mobile-dropdown]');
    el.classList.remove('is-open');
    if (windowWidth() > breakpointMd) {
      slideUp(openDropdown, 300);
    }
  });
}

const menuSlideToggle = (elem, parent) => {
  if (parent.classList.contains('is-open')) {
    slideUp(elem, 300);
    parent.classList.remove('is-open');
  } else {
    closeOtherMenu();
    parent.classList.add('is-open');
    slideDown(elem, 300);
  }
};

// Open submenu
const menuLink = document.querySelectorAll('.menu__item.has-submenu > .menu__link');

menuLink.forEach((item) => {
  const parentElem = item.closest('.menu__item');
  const dropDownElem = parentElem.querySelector('.menu__dropdown');
  item.addEventListener('click', (e) => {
    if (windowWidth() > breakpointMd) {
      menuSlideToggle(dropDownElem, parentElem);
    } else {
      parentElem.classList.toggle('is-open');
    }
    e.preventDefault();
  });
});

// Menu backarrow for mobile
attachEvent('.menu__back-arrow', 'click', (ev) => {
  const arrowParent = ev.target.closest('.menu__item');
  arrowParent.classList.remove('is-open');
});

// Open language dropdown
attachEvent('.language__placeholder', 'click', (ev) => {
  const parentElem = ev.target.closest('.language');
  parentElem.classList.toggle('is-open');
});

// Languge backarrow for mobile
attachEvent('.language__back-arrow', 'click', (ev) => {
  const arrowParent = ev.target.closest('.language');
  arrowParent.classList.remove('is-open');
});

// Close menu on `esc` key pressed
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.body.classList.remove('is-open-menu');
  }
});

// Close menu when clicked on outside
const menuContainer = document.querySelector('.header-main');

document.addEventListener('click', (evt) => {
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === menuContainer) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  document.body.classList.remove('is-open-menu');
});
